import React from 'react'
import { CSSTransition } from 'react-transition-group'

import styles from './scrim.module.css'

interface ScrimProps {
  isVisible: boolean
  onClick?: () => any
}

const Scrim: React.FC<ScrimProps> = ({ isVisible, onClick }) => {
  return (
    <CSSTransition
      in={isVisible}
      timeout={250}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        enterDone: styles.enterDone,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      unmountOnExit={true}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <div data-testid="scrim" role="presentation" className={styles.scrim} onClick={() => onClick && onClick()} />
    </CSSTransition>
  )
}

export default Scrim
